import APIService from '@/services/APIService.js';

export default {
  getAllItems(includeExpiredRecords) {
    return APIService.apiCall().get(`/variacoesPrecoUnitario/getAllEntities/${includeExpiredRecords}`);
  },
  getItem(id) {
    return APIService.apiCall().get(`/variacoesPrecoUnitario/getEntity/${id}`);
  },
  salvarItem(postData, id) {
    return APIService.apiCall().post(`/variacoesPrecoUnitario/salvar/${id}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/variacoesPrecoUnitario/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/variacoesPrecoUnitario/executar/${id}`);
  },
  getDadosRelatorio(id, variavel, order) {
    return APIService.apiCall().get(`/variacoesPrecoUnitario/getDadosRelatorio/${id}?var=${variavel}&order=${order}`);
  },
  downloadLogs(postData) {
    return APIService.apiCall().post('/variacoesPrecoUnitario/downloadLogs/', JSON.stringify(postData), {
      responseType: 'blob',
      ...{ timeout: 60 * 60 * 1000 }
    });
  }
};
